import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { UserRoleConstants } from '@app/core/staff/store/staff.model';
import { environment } from '@app/env-service';

import {
  ADMIN_DENIED_PERMISSIONS,
  SALES_MEMBERS_DENIED_PERMISSIONS,
} from '../store/permissions.model';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(
    private authService :AuthService,
    private http :HttpClient,
  ) {}

  private readonly _rPermissions = new BehaviorSubject<RPermission>({});
  public rPermissions$ = this._rPermissions.asObservable();

  can(permission :string) :boolean {
    if (this.authService.loginUser.role === UserRoleConstants.SALES_MEMBER) {
      return this.salesMemberCan(permission);
    } else if (this.authService.loginUser.role === UserRoleConstants.ADMIN) {
      return this.adminCan(permission);
    }

    return true;
  }

  private adminCan(permission :string) :boolean {
    return ADMIN_DENIED_PERMISSIONS.indexOf(permission) < 0;
  }

  private salesMemberCan(permission :string) :boolean {
    return SALES_MEMBERS_DENIED_PERMISSIONS.indexOf(permission) < 0;
  }

  // new role-based permission methods
  // this method relies on refreshing the app on sign-in/out, so it gets called on each app init
  public getRbac() {
    if (this.authService.loginUser) {
      return this.http
        .get<RPermissionResponse>(`${environment.urlV2}/rbac/my-permissions`)
        .toPromise()
        .then((res) => {
          this._rPermissions.next(
            res.reduce((acc, next) => ({ ...acc, [next.name]: true }), {}),
          );
        });
    }

    return Promise.resolve();
  }

  public getDisplayPageSettings() :Observable<any> {
    return this.http.get<any>(`${environment.urlV2}/display-pages`);
  }
}
